const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof jdfy_ops_ui !== "undefined") return resolve();
	__webpack_require__.l("https://jdfy-ops.deere.com/ops/latest/remoteEntry.js", (event) => {
		if(typeof jdfy_ops_ui !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "jdfy_ops_ui");
}).then(() => (jdfy_ops_ui));